import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { selectApp, goToPage, showLeaderboards } from '../../HOME/REDUX/actions';
import BackIcon from '../../HOME/SVG/BackIcon';
import { hideLeaderboards } from '../../HOME/utils';
import { START_PAGE, GAME_PAGE, HIDE, SKILL_PAGE, HELP_PAGE } from '../../HOME/const';
import useGoHome from '../../HOME/useGoHome';

const BackButton = props => {
  const goHome = useGoHome();

  if (props.singleApp && props.page === START_PAGE) {
    return null;
  }

  return (
    <div
      className="navigation-button"
      onClick={() => {
        switch (props.page) {
          case START_PAGE:
            goHome();
            return;
          case SKILL_PAGE:
            props.goToPage(START_PAGE);
            break;
          case GAME_PAGE:
            if (props.showLeaders === HIDE) {
              props.goToPage(START_PAGE);
            } else {
              hideLeaderboards(props.showLeaderboards);
            }
            return;
          case HELP_PAGE:
            props.goToPage(props.fromPage || START_PAGE);
            return;
          default:
            return;
        }
      }}>
      <BackIcon width="36" />
    </div>
  );
};

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, selectApp, showLeaderboards }
)(BackButton);
